import { render, staticRenderFns } from "./selectPosition.vue?vue&type=template&id=de9fae5e&scoped=true"
import script from "./selectPosition.vue?vue&type=script&lang=js"
export * from "./selectPosition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de9fae5e",
  null
  
)

export default component.exports